import postRequest from 'utils/postRequest'
import getRequest from 'utils/getRequest'
import deleteRequest from 'utils/deleteRequest'
import filterUndefinedFromObject from 'utils/filterUndefinedFromObject'
import patchRequest from 'utils/patchRequest'

const path = '/api/criterion-c'
const reassessmentPath = '/api/reassessment/sites'

export const requestCreateCriterionC = (siteId, siteHistoryId) => {
    const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/criterion-c` : `${path}/${siteId}`
    return postRequest(url)
}

export const deleteCriterionC = (criterionCId, siteHistoryId) => {
    const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/criterion-c/${criterionCId}` : `${path}/${criterionCId}`
    return deleteRequest(url)
}

export const requestGetCriterionCs = async (siteId, siteHistoryId) => {
    const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/criterion-c` : `${path}/${siteId}`
    return await getRequest(url)
}

export const requestGetAllCriterionCs = () => {
    return getRequest(`${path}?select=name`)
}

export const requestUpdateCriterionC = async(criterionCId, siteHistoryId, {
    ecoregion_id,
    ecoregion_c_sites_count,
    year,
    evidence_low_human_impact,
    evidence_intact_ecology,
    trigger_reason_id,
    trigger_reason_text,
}) => {

    const requestBody = filterUndefinedFromObject({
        ecoregion_id,
        ecoregion_c_sites_count,
        year,
        evidence_low_human_impact,
        evidence_intact_ecology,
        trigger_reason_id,
        trigger_reason_text,
    })

    if (siteHistoryId) {
        return await patchRequest(`${reassessmentPath}/${siteHistoryId}/criterion-c/${criterionCId}`, requestBody)
    }
    return await patchRequest(`${path}/${criterionCId}`, requestBody)
}

export const confirmCriterionC = async (criterionCId, isApproved) => {
    return await postRequest(`${path}/${criterionCId}/confirm`, isApproved)
}

export const cancelCriterionCReassessmentRequest = ({ siteId, criterionCId, isCancelled }) => {
    return postRequest(`${reassessmentPath}/${siteId}/criterion-c/${criterionCId}/cancel`, { isCancelled: isCancelled })
}
